export default (value: any = 0) => {
    const PATTERN = /\B(?=(\d{3})+(?!\d))/g;
    if (typeof value === 'string') value = +value;
    value = String(value).replace(PATTERN, '.' );
    if (!value || value === null) value = 0;
    return value;
};
